import styles from "./listing.module.css";
import {useParams, useNavigate} from "react-router-dom";
import {useEffect, useState} from "react";
import {useAuth} from "../../context/AppAuthContext";
import ListingObject from "../../components/listing_object/listing_object";
import {Spin, Button, Result, message, Flex} from "antd";
import {useApp} from "../../context/AppDataContext";
import UserObject from "../../components/user_object/user_object";

export default function Listing() {
    const {listingID} = useParams();
    const [listingData, setListingData] = useState(null);
    const {getListingData} = useAuth();
    const navigate = useNavigate();
    const {isLoading, setIsLoading, error} = useApp();

    console.log(listingID)
    useEffect(() => {
        const fetchListing = async () => {
            try {
                if (listingData === null) {

                    if (!listingID) {
                        throw new Error("No listing ID provided");
                    }

                    setIsLoading(true);
                    const response = await getListingData(listingID);
                    console.log(response.data)
                    if (response.data) {
                        setListingData(response.data);
                    } else {
                        throw new Error("Listing not found");
                    }
                }
            } catch (err) {
                console.error("Failed to fetch listing:", err);
                message.error(err.message || "Failed to load listing details");
            } finally {
                setIsLoading(false);
            }
        };
        fetchListing();
    }, [listingID]);


    return (
        <div className={styles.listing_container}>
            {listingData && <ListingObject listingData={listingData}/>}
            {listingData && <UserObject userObject={listingData.user}/>}
        </div>
    );
}